import React from "react"
import ReactDOM from "react-dom"
import ProductStockOverlay from "./component/productStockOverlay"
import PdpButton from "./component/pdpButton"

export default class ProductStockOverlayModule {
  constructor(elem) {
    this.elem = elem
    this.elem.stores = JSON.parse(elem.dataset.stores || "")
    this.elem.showButton = this.elem.stores.length > 0
    this.elem.endpointUrl = elem.dataset.endpointUrl
    this.elem.productId = elem.dataset.productId
    this.elem.inWebStock = elem.dataset.inWebStock === "True"
    this.elem.alwaysShowStock = elem.dataset.alwaysShowStock === "True"
    this.elem.textKeys = JSON.parse(elem.dataset.textKeys || "")
    this.overlayButton = document.getElementById("stock-overlay-button")
    this.init()
  }

  init() {
    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.render(
      <ProductStockOverlay
        textKeys={this.elem.textKeys}
        endpointUrl={this.elem.endpointUrl}
        stores={this.elem.stores}
        productId={this.elem.productId}
        inWebStock={this.elem.inWebStock}
        alwaysShowStock={this.elem.alwaysShowStock}
      />,
      this.elem,
    )
    if (this.overlayButton) {
      ReactDOM.unmountComponentAtNode(this.overlayButton)
      ReactDOM.render(<PdpButton textKeys={this.elem.textKeys} showButton={this.elem.showButton} />, this.overlayButton)
    }
  }
}
